import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { LANGUAGES } from '../shared/constants.js';
import { isRTL } from '../i18n/config.js';

export default function LanguageSelector({ variant = 'outline-light', size = 'sm', className = '' }) {
  const { i18n } = useTranslation();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  const currentLanguage = LANGUAGES.find(lang => lang.code === i18n.language) || LANGUAGES[0];
  
  // For RTL on mobile, use 'start' alignment to prevent cutoff on left side
  // For LTR or desktop, use 'end' alignment
  const menuAlign = isRTL(i18n.language) ? 'start' : 'end';

  return (
    <Dropdown className={className}>
      <Dropdown.Toggle variant={variant} size={size} id="language-selector">
        <span>{currentLanguage.flag}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu align={menuAlign} className="language-selector-menu">
        {LANGUAGES.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            active={i18n.language === lang.code}
          >
            {lang.nativeName}
            {i18n.language === lang.code && (
              <i className={`bi bi-check ${isRTL(i18n.language) ? 'me-2' : 'ms-2'}`}></i>
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
